<template>
  <div>
      <b-form-group class="input-group-var-genere" label="Gènere:" label-size="sm" label-for="input-var-genere"  label-cols="4" label-cols-lg="2">
        <b-form-select required size="sm" id="input-var-genere" class="var-genere" v-model="genere" :options="opcionsGenere" @input="onUpdateGenere">
           <template v-slot:first>
            <b-form-select-option :value="null">Tots</b-form-select-option>
          </template>
        </b-form-select>
      </b-form-group>
  </div>
</template>

<script>
export default {
  name: "VariableGenere",
  props: {
    initialValue:{      
      required: true
    }
  },  
  data() {
    return {
      codiVariable: 'genere',
      genere: null,
      opcionsGenere: [
          { value: 'H', text: 'Home' },
          { value: 'D', text: 'Dona' }
      ]
    };
  },
  computed:{
    returnValue(){
      let r = {codi: this.codiVariable}
      if(this.genere!=null ){
        r.valor = this.genere;
      }

      return r;
    }
  },    
  methods: {    
    onUpdateGenere(newValue){      
      console.log(newValue)
      if(this.returnValue.valor){
        this.$emit('variable-editada', this.returnValue)        
      }else{
        this.$emit('variable-eliminada', this.codiVariable)        
      }      
    }
  },
  mounted() {
    if(this.initialValue!=null){
      this.genere = this.initialValue.valor}
    }
};
</script>

<style>
.var-genere{
   width: 180px;
}
.input-group-var-genere .col{
  text-align: left;
}
</style>